import React from 'react';
import styled from 'styled-components';

import { useAdminGetDashboardUsersDataQuery } from '../../hooks/reactQuery/dashboard/useAdminGetDashboardUsersDataQuery';
import { icons } from '../../themes/icons';
import { toLocaleString } from '../../utils/format-number';
import { CardError } from './CardError';
import StatCard from './StatCard';

export const Users: React.FC = () => {
  const { data, isFetching, isError, refetch } = useAdminGetDashboardUsersDataQuery();

  return (
    <BoxContainer>
      <AllStats>
        <Heading>Models</Heading>
        <Time>Total</Time>
      </AllStats>
      {isError && !isFetching && <CardError onRetry={() => refetch()} />}
      {!isError && (
        <>
          <StatCard
            isFetching={isFetching}
            isDesktop
            name="Models"
            count={toLocaleString(data?.totalAgencyModels || 0)}
            icon={<icons.SheildBlueIcon />}
          />
          <StatCard
            isFetching={isFetching}
            isDesktop
            name="Freelancer"
            count={toLocaleString(data?.totalFreelancerModels || 0)}
            icon={<icons.UserBlueIcon />}
          />
          <StatCard
            isFetching={isFetching}
            isDesktop
            name="Beautypass Select"
            count={toLocaleString(data?.totalBPSelectModels || 0)}
            icon={<icons.UserStarBlueIcon />}
          />
          <StatCard
            isFetching={isFetching}
            isDesktop
            name="Lifestyle"
            count={toLocaleString(data?.totalLifestyleModels || 0)}
            icon={<icons.UserBlueIcon />}
          />
        </>
      )}
    </BoxContainer>
  );
};

const AllStats = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #0000000d;
  padding-bottom: 15px;
`;

const Heading = styled.div`
  color: #111111;
  font-size: 18px;
  font-family: Poppins;
  font-weight: 500;
`;

const Time = styled.div`
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  font-family: Poppins;
  font-weight: 500;
`;
const BoxContainer = styled.div`
  margin-top: 20px;
  border: 1px solid #00000014;
  border-radius: 8px;
  padding: 30px;
`;
